'use strict';

var _isNil = require('lodash/isNil');

var ValidationSuccess = require('../models/validation-success');
var ValidationFailure = require('../models/validation-failure');

module.exports = function buildSimpleValidator(validatorFunction, failureMessageFunction, requiredValidationProps) {
  return function (value, validationOptions) {
    if (requiredValidationProps && !requiredValidationProps.every(function (prop) {
      return !_isNil(validationOptions[prop]);
    })) {
      throw new Error('The given field is missing one or more required properties for validation.');
    }

    var valueValid = validatorFunction(value, validationOptions);

    if (valueValid) {
      return new ValidationSuccess();
    }

    var failureMessage = typeof failureMessageFunction === 'function' ? failureMessageFunction(value, validationOptions) : failureMessageFunction;

    return new ValidationFailure(failureMessage);
  };
};